import { DataGrid } from "@mui/x-data-grid";

import { ptBRGrid } from "../../../Boletos/tableConfig/translateptBR";
import { getStatus } from "../../services/getStatus";

const Desktop = ({ setOpen, setInfo, newEntregas }) => {
  return (
    <DataGrid
      onRowClick={({ row }) => {
        getStatus(
          row.numnota,
          row.details,
          setOpen,
          setInfo,
          row.productsArr,
          row.qtdsArr,
          row.seriesArr
        );
      }}
      rows={newEntregas}
      sx={{
        ".MuiDataGrid-cell:focus": {
          outline: "none",
        },
        "& .MuiDataGrid-row:hover": {
          cursor: "pointer",
        },
      }}
      columns={[
        { field: "data", headerName: "Data", width: 150 },
        { field: "products", headerName: "Produtos", width: 600 },
        { field: "numnota", headerName: "Nº da Nota", width: 150 },
      ]}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[10]}
      disableRowSelectionOnClick
      localeText={ptBRGrid}
    />
  );
};

export default Desktop;
